import { ChangeEvent, InputHTMLAttributes, memo, ReactNode } from 'react';

import { clsx } from 'clsx';

import cls from './Radio.module.scss';

type HTMLInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'readOnly' | 'size'>;

type RadioVariant = 'default';

export type RadioProps = HTMLInputProps & {
  className?: string;
  classNameLabel?: string;
  value?: boolean;
  onChange?: (value: boolean) => void;
  label?: ReactNode;
  variant?: RadioVariant;
  testId?: string;
};

export const Radio = memo(
  ({ className, value, onChange, label, classNameLabel, variant = 'default', testId, ...rest }: RadioProps) => {
    const onChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
      if (onChange) onChange(event.target.checked);
    };

    const mods = {
      [cls.active]: value
    };

    return (
      <label className={clsx(cls.wrap, className, mods, [cls[variant]])}>
        <input
          data-testid={testId}
          className={cls.input}
          type="radio"
          checked={value}
          onChange={onChangeHandler}
          {...rest}
        />
        <span className={cls.icon}></span>

        {label && <span className={clsx(cls.label, classNameLabel)}>{label}</span>}
      </label>
    );
  }
);
